export default Object.freeze({
    all: 'All',
    keepsakes: 'Keepsakes',
    memorialisation: 'Memorial Items',
    urns: 'Urns',
    metalUrns: 'Metal Urns',
    ceramicUrns: 'Ceramic Urns',
    vetSupplies: 'Vet Supplies',
    cremationPackages: 'Cremation Packages'
});
